import styled, { createGlobalStyle } from 'styled-components';
import { Badge, Button } from 'antd';

export const NotificationGlobalStyles = createGlobalStyle<{
  isToast: boolean;
  alarmData: boolean;
}>`
  .notification-toast .ant-notification-notice-message {
    padding: 0 !important;
    margin: 0 !important;
  }

  .notification-toast .ant-notification-notice {
    border-radius: 0px !important;
  }

  .notification-toast .ant-notification-notice-close {
    top: 4px;
    right: 8px;
    color: ${({ theme }) => theme.colors.text};
    ${({ isToast }) => isToast && `display: none;`}
    ${({ alarmData }) => !alarmData && `display: none;`}
  }
`;

export const NotificationContainer = styled.div<{ isToast: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  ${({ isToast }) => isToast && `border: none;`}
  position: relative;
  height: 100%;
`;

export const Subtitle = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  max-width: 100%;
`;

export const LinkButton = styled(Button)`
  padding: 4px 0px 4px 15px !important;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const StatusBadge = styled(Badge)<{
  variant: 'critical' | 'ok' | 'crit' | 'recovery';
}>`
  color: ${({ variant, theme }) =>
    variant === 'critical' || variant === 'crit'
      ? theme.colors.red
      : theme.colors.green};
  border: 1px solid
    ${({ variant, theme }) =>
      variant === 'critical' || variant === 'crit'
        ? theme.colors.red
        : theme.colors.green};
  background-color: transparent;
  padding: 2px 8px;
  border-radius: 8px;
  line-height: 1.5715;
  font-size: 14px;
`;

export const AlarmTypeBadge = styled(Badge)`
  color: ${({ theme }) => theme.colors.text1};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background-color: transparent;
  padding: 2px 8px;
  border-radius: 8px;
  line-height: 1.5715;
  font-size: 14px;
`;

export const BadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  justify-content: space-between;
  align-items: center;
  min-height: 32px;

  .ant-btn {
    padding: 0 !important;
  }
`;

export const NotificationContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .ant-btn-default svg {
    color: ${({ theme }) => theme.colors.label};
  }
`;
